import { h, ComponentChildren, JSX } from "preact";
import { useRef, useState } from "preact/hooks";

import { cmdKey } from "../../utils/keyboard";
import Link from "../Link";

interface Props extends JSX.HTMLAttributes<HTMLAnchorElement> {
    link?: string;
    children: ComponentChildren;
    onClick?: (ev: MouseEvent) => void;
}

const DOUBLE_CLICK_CLEAR_TIMEOUT = 500; // ms

function DoubleClickLink({
    link = "",
    children,
    onClick,
    ...props
}: Props) {
    const [activeLink, setActiveLink] = useState("");

    const linkClearTimeout = useRef<ReturnType<typeof setTimeout> | undefined>();

    function handleSetActiveLink() {
        setActiveLink(link);

        clearTimeout(linkClearTimeout.current);
        linkClearTimeout.current = setTimeout(() => {
            setActiveLink("");
        }, DOUBLE_CLICK_CLEAR_TIMEOUT);
    }

    function handleClick(ev: MouseEvent) {
        const cmdPressed = cmdKey(ev);
        const shiftPressed = ev.shiftKey;

        // Prevent opening link in new tab on the first click
        if (activeLink === "" && (cmdPressed || shiftPressed)) {
            ev.preventDefault();
        }

        handleSetActiveLink();
        onClick?.(ev);
    }

    return (
        <Link
            to={activeLink}
            onClick={handleClick}
            {...props}>
            {children}
        </Link>
    );
}

export default DoubleClickLink;
